import { createFileRoute } from '@tanstack/react-router'
import { ContractsSection } from '~/components/marketing/contracts-section'
import { DocumentsSection } from '~/components/marketing/documents-section'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { ReportsSection } from '~/components/marketing/reports-section'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'Deliverables — documents, reports and contracts | Planno'
const PAGE_DESCRIPTION =
  'Collaborative documents, monthly progress reports in three formats, and contracts with the cover an architecture practice needs.'

export const Route = createFileRoute('/en/features/deliverables')({
  component: DeliverablesPage,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'en',
      path: '/en/features/deliverables',
      title: PAGE_TITLE,
    }),
})

function DeliverablesPage() {
  return (
    <MarketingShell locale="en">
      <DocumentsSection headingLevel="h1" />
      <ReportsSection />
      <ContractsSection />
    </MarketingShell>
  )
}
